import {inject, Injectable, signal} from '@angular/core';
import {ControlStore} from 'frontier/nucleus';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Injectable({
    providedIn: 'root'
})
export class LetterOfResignationService {
    url = signal<string>(null);
    controlStore = inject(ControlStore);

    constructor() {
        this.controlStore.tenantChanged$.pipe(takeUntilDestroyed()).subscribe(() => this.url.set(null))
    }
}
